// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/img/line_bg1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/img/Union.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width: 760px) {
  html,
  body,
  #root {
    height: 100%;
    width: 100%;
  }
  body,
  #home-root {
    /* ... */
    overflow: hidden;
  }
  #root {
    overflow-x: hidden;
    overflow-y: scroll;
  }
  #root::before {
    background: #131313 url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 50% 80vh;
  }
  .impact.movable {
    width: 97vw;
    padding-bottom: 5vh;
    margin-left: -7%;
  }
  .grey {
    height: auto;
  }
  .impact li {
    margin-top: 1.5em;
    width: 100%;
  }
  .etools,
  .capps,
  .pauto,
  .monitor {
    background-size: 10%;
  }
  ul,
  .flex-row {
    flex-direction: column;
  }
  ul.nav.fusion {
    flex-direction: row;
  }
  .magic-section {
    position: relative;

    transform: translate(0%, 0px);
    opacity: 1;
  }
  h3.magic-section-animate {
    transform: translate(0%, 0px);
  }
  .flex-row > div {
    width: 100%;
  }
  .magic-content,
  .magic-section h3 {
    padding-left: 8.6%;
  }
  .magic-section h3 {
    transform: translate(0%, 0px);
    opacity: 1;
  }
  .banner {
    height: 100vh;
    max-height: 660px;
  }
  .banner h1 {
    font-size: 2.2em;
    font-weight: 800;
  }
  .fullpage {
    min-height: 80vh;
    height: auto;
    box-sizing: border-box;
  }
  .third-left-child {
    margin-top: 1.5em;
  }
  .banner .fusion {
    margin-top: 0.75em;
  }
  .fusion li {
    line-height: 1.7em;
    font-size: 0.6em;
    height: 2em;
    font-weight: 500;
  }
  .nav li {
    margin-right: 1em;
  }
  .content-section {
    width: 90%;
    position: relative;
    padding-top: 2em;
  }
  .content-section > div {
    font-size: 5vw;
  }
  .colorfultext,
  .contact-banner .colorfultext {
    background: linear-gradient(90deg, #ffde31 41.31%, #ff3db2 55.42%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .work-details-child h3 {
    font-size: 12vw;
  }
  .work-details-child h3 b {
    font-weight: 700;
  }
  .font-5-reasons {
    font-size: 1.6em;
  }
  h3 {
    font-size: 1.8em;
  }
  .movable {
    width: 100%;
  }
  .movable-parallax-1- {
    margin-top: 0px;
  }
  .carousel {
    width: 100%;
    margin: 0;
    display: block;
  }
  .carousel li {
    width: 100%;
  }
  .scalable,
  #scroll-horizontal {
    height: auto;
  }
  .scalable {
    background-color: rgba(0, 0, 0, 0.6);
  }
  /* .content{
      height: 18rem;
    } */

  button {
    padding: 0 2em;
    font-size: 0.8em;
    width: 80%;
  }
  .announcemnet-cover,
  .listening-triangle {
    left: -5.5%;
  }
  .announcemnet-cover {
    top: -0.5px;
  }
  .scalable > .content-section {
    color: #fff;
    margin: 0 auto;
    padding: 1em 0;
  }
  .scalablebg {
    height: auto;
    padding: 0em 0em 4em 0em;
  }
  .carousel img {
    width: 80%;
    height: 100%;
    margin: 3%;
  }
  .mobile-only {
    display: block;
  }
  .burger-menu {
  }
  .web-only {
    display: none;
  }
  .magic-section {
    left: 0;
    z-index: 5;
    padding-bottom: 10%;
    /* background: #131313 url("../assets/img/line_bg1@3x.png") no-repeat 0% 100%;
      background-size: 50% 60%; */
    color: #fff;
  }
  .magic-section p {
    font-size: 1em;
    padding: 1.65em;
  }
  .flex-row .magic-section {
    padding-top: 10em;
  }
  .carousel-container,
  .contact-mobile {
    padding-top: 3em;
  }
  .seperator {
    display: none;
  }
  .carousel div {
    width: 100%;
    height: 12em;
  }

  .content p {
    margin-bottom: 0;
  }
  .about-banner {
    background-size: 450%;
    background-position: bottom;
  }
  .top-pad-header-mobile {
    padding-top: 70%;
  }
  .seperator-right {
    padding-left: 0;
  }
  .left-of-seperator,
  .right-of-seperator {
    width: 100%;
    font-size: 0.75em;
    padding: 0;
    text-align: left;
  }
  .left-of-seperator h4,
  .right-of-seperator h4 {
    font-weight: 600;
    font-size: 1.4em;
  }
  .item-right p {
    padding-right: 0em;
  }

  .right-of-seperator {
    margin-top: 1.5em;
    margin-left: 0;
  }
  .row-ul-mobile {
    flex-direction: row;
  }
  .underlined-text {
    padding-bottom: 2em;
  }
  .about-done-that .nav li,
  .reasons {
    display: none;
  }
  .about-done-that h3 {
    font-size: 1.4em;
  }

  .reason-mobile {
    background: linear-gradient(
      163.54deg,
      #676767 10.41%,
      #0d0d0d 36.63%,
      #131313 100%
    );
    margin-top: -5%;
    color: #fff;
  }
  .reason-heading-mobile {
    padding: 3em 0 13em;
    font-size: 1em;
    text-align: center;
  }
  .triangle-right {
    width: 0;
    height: 0;
    border-top: 30vh solid transparent;
    border-left: 100vw solid rgb(89, 89, 89);
    border-bottom: 30vh solid transparent;
    position: relative;
    margin-top: -30vh;
  }
  .triangle-left {
    width: 0;
    height: 0;
    border-top: 30vh solid transparent;
    border-right: 100vw solid rgb(66, 66, 66);
    border-bottom: 30vh solid transparent;
    margin-top: -30vh;
    position: relative;
  }
  .triangle-right h4 {
    right: 38vw;
    position: absolute;
    top: -1.2em;
    width: 55vw;
    text-align: left;
    text-transform: uppercase;
    font-size: 1.4em;
  }
  .triangle-left h4 {
    left: 35vw;
    position: absolute;
    top: -1em;
    width: 55vw;
    text-align: right;
    text-transform: uppercase;
    font-size: 1.4em;
  }
  .triangle-right p {
    right: 42vw;
    position: absolute;
    top: 0.5em;
    width: 51vw;
    text-align: left;
    font-size: 5.5vw;
  }
  .triangle-left p {
    left: 40vw;
    position: absolute;
    top: 0.7em;
    width: 50vw;
    text-align: right;
    font-size: 5.5vw;
  }
  .solve,
  .bvb,
  .reality {
    background-size: 15%;
  }
  /* h3{
  font-size: 1.4em;
} */
  .mobile-top-spacing {
    padding-top: 1em;
  }
  h4 {
    font-size: 1.2em;
  }
  .mailbox {
    padding: 2.5em 2% 2.5em 7% !important;
  }
  .footer-contact {
    display: flex;
    width: 100%;
    flex-direction: column;
    font-size: 0.6em;
  }
  .footer-contact div:nth-child(1) {
    padding: 0;
    padding-top: 2em;
  }
  .footer-contact div:nth-child(2) {
    padding: 0;
    padding-bottom: 2em;
  }
  .seperator-friendly {
    padding: 2em 0 0;
    text-align: left;
  }
  .seperator-friendly h3 {
    font-weight: bold;
  }
  svg {
    height: 80vh;
  }
  .work-banner h2,
  .about-banner h2,
  .contact-banner h2 {
    font-size: 9vw;
    width: 90%;
    align-self: center;
  }
  .work-banner div,
  .about-banner div {
    gap: 2.5em;
  }
  .third-left-child {
    margin-top: 1.5em;
  }
  .custom-questionnaire {
    margin: 0.5em 1.5em 0.5em 0.5em;
    min-height: 50vh;
    height: auto;
    max-height: 500vh;
    z-index: 0;
  }
  .MuiStepLabel-root .MuiStepLabel-labelContainer .Mui-active {
    font-size: 1em;
  }
  .user-box,
  .email-box {
    padding-left: 3em;
  }
  .email-submit {
    background: #eee url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat 34% 52%;
    background-size: auto 50%;
  }

  .form-function-text {
    font-size: 1.8em;
    line-height: 1.1em;
  }
  .solution-img {
    width: 100%;
    opacity: 1;
    transform: translate(0%, 0%);
  }
  .solution-img-opposite {
    width: 100%;
    opacity: 1;
    transform: translate(0%, 0%);
  }
  .emr,
  .itlfm {
    margin: 0;
    background-position: 0 0;
  }
  .work-details li {
    height: 60vh;
  }
  .products-home {
    width: 100%;
    margin-top: 4vh;
  }
  .products-home > div {
    margin-bottom: 5vh;
    position: relative;
  }
  .products-home > div > img {
    width: 100%;
    cursor: pointer;
  }
  .fleetimg {
    margin-left: -20%;
    /* width: 120vh; */
  }
  .fleet .picarroimg {
    margin-left: -15%;
  }
  .products-home p {
    position: absolute;
    bottom: 0em;
    width: 100%;
    text-align: center;
  }
  .products-home p:nth-child(2) {
    display: none;
  }
  .carousel-bg {
    height: 25vh;
  }
  .MuiBox-root {
    width: 100%;
  }
  .contactus-form {
    width: 95%;
  }
  .email-submit {
    right: -2%;
  }
  .thankyou-font {
    font-size: 2em;
    left: 0;
  }
  .thanksyou-wrapper {
    left: 0;
    top: 45vh;
    width: 100%;
  }
  .thanksyou-wrapper > p {
    padding: 0em 2.5em 0em 2.5em;
    text-align: center;
  }

  .about-map-img {
    width: 100%;
    height: 40vh;
  }
  .services-content {
    margin-top: 0;
    line-height: 0;
  }
  .services-text {
    padding-top: 0em;
  }
  .reasons-heading {
    padding-bottom: 3em;
    padding-top: 1em !important;
  }
  .modal-content-wrapper {
    overflow-y: scroll;
    height: 100vh;
    padding-bottom: 1em;
    background-color: #000;
    overflow-y: scroll !important;
    -webkit-overflow-scrolling: touch;
  }
  .modal-text-wrapper {
    color: white;
    background: black;
    padding: 2em;
    height: 95vh;
  }
  .modal-text-wrapper a {
    color: #fff;
    font-weight: 600;
  }
  .say-hi-class {
    width: 90%;
  }
  .gta img {
    height: 100vh !important;
    width: auto !important;
    margin-left: -12% !important;
  }
  .ehr,
  .pandemic,
  .gta,
  .fleet,
  .italos {
    opacity: 1;
    transform: translate(0%, 0%);
  }
  .work-details-child {
    position: relative;
  }
  .work-details-child .mobile-only {
    position: absolute;
    top: 0;
    height: 100%;
    z-index: 1;
    color: #fff;
    width: 100%;
    background: linear-gradient(
      180deg,
      rgba(4, 4, 4, 0) 47.92%,
      rgba(4, 4, 4, 0.5) 100%
    );
    font-weight: bold;
    font-size: 2em;
  }
  .work-details-child .mobile-only h3 {
    bottom: 1em;
    left: 5vw;
    position: absolute;
  }

  .lazy-images-odd {
    width: 100vh !important;
    margin-left: -22%;
  }

  .lazy-load-image-background {
    overflow: hidden;
  }

  .lazy-images-even {
    /* width: 100vh !important; */
    margin-left: -52%;
  }
  .italos img {
    height: 100vh !important;
    width: auto !important;
    margin-left: -12%;
  }
}

.appimg {
  display: grid;
  grid-template-columns: 1fr 2fr;
  align-items: center;
  padding-bottom: 4vmin;
  height: 40vh;
  width: 40%;
  background: #ede8e2;
  color: #3a3535;
  visibility: hidden;
}
.image {
  grid-row: 1;
  grid-column: 1;
  margin-left: -2rem;
  opacity: 0.7;
  animation: image-in 1s cubic-bezier(0.5, 0, 0.1, 1) 0s backwards;
  visibility: visible;
}
.nextChoice-container {
  padding: 0.75em;
}
.delay1 {
  animation: image-in 1s cubic-bezier(0.5, 0, 0.1, 1) 1s backwards;
}
.delay2 {
  animation: image-in 1s cubic-bezier(0.5, 0, 0.1, 1) 2s backwards;
}
@keyframes image-in {
  from {
    clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
  }
  to {
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  }
}
.image img {
  display: block;
  width: 100%;
  height: auto;
  filter: grayscale(30%);
}
.image img:hover {
  filter: grayscale(0%);
}

.close-icon {
  position: absolute;
  right: 0.5em;
  top: 0.5em;
  width: 1.5em;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 0.75em;
}
.close-icon img {
  width: 1.5em;
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.mobile.css"],"names":[],"mappings":"AAAA;EACE;;;IAGE,YAAY;IACZ,WAAW;EACb;EACA;;IAEE,QAAQ;IACR,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,8EAAsE;EACxE;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;EACA;;;;IAIE,oBAAoB;EACtB;EACA;;IAEE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;;IAElB,6BAA6B;IAC7B,UAAU;EACZ;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,WAAW;EACb;EACA;;IAEE,kBAAkB;EACpB;EACA;IACE,6BAA6B;IAC7B,UAAU;EACZ;EACA;IACE,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;;IAEE,kEAAkE;IAClE,6BAA6B;IAC7B,oCAAoC;EACtC;;EAEA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,SAAS;IACT,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;;IAEE,YAAY;EACd;EACA;IACE,oCAAoC;EACtC;EACA;;OAEK;;EAEL;IACE,cAAc;IACd,gBAAgB;IAChB,UAAU;EACZ;EACA;;IAEE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,cAAc;IACd,cAAc;EAChB;EACA;IACE,YAAY;IACZ,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,YAAY;IACZ,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA;EACA;EACA;IACE,aAAa;EACf;EACA;IACE,OAAO;IACP,UAAU;IACV,mBAAmB;IACnB;iCAC6B;IAC7B,WAAW;EACb;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,WAAW;IACX,iBAAiB;IACjB,UAAU;IACV,gBAAgB;EAClB;EACA;;IAEE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE;;;;;KAKC;IACD,eAAe;IACf,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,wCAAwC;IACxC,qCAAqC;IACrC,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,yCAAyC;IACzC,qCAAqC;IACrC,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,gBAAgB;EAClB;EACA;;;IAGE,oBAAoB;EACtB;EACA;;GAEC;EACD;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,qCAAqC;EACvC;EACA;IACE,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;;;IAGE,cAAc;IACd,UAAU;IACV,kBAAkB;EACpB;EACA;;IAEE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,+BAA+B;IAC/B,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA;;IAEE,iBAAiB;EACnB;EACA;IACE,0EAA+D;IAC/D,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,WAAW;IACX,UAAU;IACV,4BAA4B;EAC9B;EACA;;IAEE,SAAS;IACT,wBAAwB;EAC1B;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;IACd,OAAO;EACT;EACA;IACE,OAAO;IACP,SAAS;IACT,WAAW;EACb;EACA;IACE,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;IACb,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;IAC7B,iCAAiC;EACnC;EACA;IACE,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,YAAY;EACd;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,sBAAsB;IACtB,4BAA4B;EAC9B;EACA;;;;;IAKE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,UAAU;IACV,WAAW;IACX,WAAW;IACX;;;;KAIC;IACD,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,WAAW;IACX,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;IAC7B,iBAAiB;EACnB;EACA;IACE,wBAAwB;IACxB,sBAAsB;IACtB,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,YAAY;EAEZ,gEAAgE;EAChE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EAEE,gEAAgE;AAClE;AACA;EAEE,gEAAgE;AAClE;AAYA;EACE;IAEE,4CAA4C;EAC9C;EACA;IAEE,kDAAkD;EACpD;AACF;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,YAAY;AACd","sourcesContent":["@media only screen and (max-width: 760px) {\n  html,\n  body,\n  #root {\n    height: 100%;\n    width: 100%;\n  }\n  body,\n  #home-root {\n    /* ... */\n    overflow: hidden;\n  }\n  #root {\n    overflow-x: hidden;\n    overflow-y: scroll;\n  }\n  #root::before {\n    background: #131313 url(../assets/img/line_bg1.svg) no-repeat 50% 80vh;\n  }\n  .impact.movable {\n    width: 97vw;\n    padding-bottom: 5vh;\n    margin-left: -7%;\n  }\n  .grey {\n    height: auto;\n  }\n  .impact li {\n    margin-top: 1.5em;\n    width: 100%;\n  }\n  .etools,\n  .capps,\n  .pauto,\n  .monitor {\n    background-size: 10%;\n  }\n  ul,\n  .flex-row {\n    flex-direction: column;\n  }\n  ul.nav.fusion {\n    flex-direction: row;\n  }\n  .magic-section {\n    position: relative;\n\n    transform: translate(0%, 0px);\n    opacity: 1;\n  }\n  h3.magic-section-animate {\n    transform: translate(0%, 0px);\n  }\n  .flex-row > div {\n    width: 100%;\n  }\n  .magic-content,\n  .magic-section h3 {\n    padding-left: 8.6%;\n  }\n  .magic-section h3 {\n    transform: translate(0%, 0px);\n    opacity: 1;\n  }\n  .banner {\n    height: 100vh;\n    max-height: 660px;\n  }\n  .banner h1 {\n    font-size: 2.2em;\n    font-weight: 800;\n  }\n  .fullpage {\n    min-height: 80vh;\n    height: auto;\n    box-sizing: border-box;\n  }\n  .third-left-child {\n    margin-top: 1.5em;\n  }\n  .banner .fusion {\n    margin-top: 0.75em;\n  }\n  .fusion li {\n    line-height: 1.7em;\n    font-size: 0.6em;\n    height: 2em;\n    font-weight: 500;\n  }\n  .nav li {\n    margin-right: 1em;\n  }\n  .content-section {\n    width: 90%;\n    position: relative;\n    padding-top: 2em;\n  }\n  .content-section > div {\n    font-size: 5vw;\n  }\n  .colorfultext,\n  .contact-banner .colorfultext {\n    background: linear-gradient(90deg, #ffde31 41.31%, #ff3db2 55.42%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n  }\n\n  .work-details-child h3 {\n    font-size: 12vw;\n  }\n  .work-details-child h3 b {\n    font-weight: 700;\n  }\n  .font-5-reasons {\n    font-size: 1.6em;\n  }\n  h3 {\n    font-size: 1.8em;\n  }\n  .movable {\n    width: 100%;\n  }\n  .movable-parallax-1- {\n    margin-top: 0px;\n  }\n  .carousel {\n    width: 100%;\n    margin: 0;\n    display: block;\n  }\n  .carousel li {\n    width: 100%;\n  }\n  .scalable,\n  #scroll-horizontal {\n    height: auto;\n  }\n  .scalable {\n    background-color: rgba(0, 0, 0, 0.6);\n  }\n  /* .content{\n      height: 18rem;\n    } */\n\n  button {\n    padding: 0 2em;\n    font-size: 0.8em;\n    width: 80%;\n  }\n  .announcemnet-cover,\n  .listening-triangle {\n    left: -5.5%;\n  }\n  .announcemnet-cover {\n    top: -0.5px;\n  }\n  .scalable > .content-section {\n    color: #fff;\n    margin: 0 auto;\n    padding: 1em 0;\n  }\n  .scalablebg {\n    height: auto;\n    padding: 0em 0em 4em 0em;\n  }\n  .carousel img {\n    width: 80%;\n    height: 100%;\n    margin: 3%;\n  }\n  .mobile-only {\n    display: block;\n  }\n  .burger-menu {\n  }\n  .web-only {\n    display: none;\n  }\n  .magic-section {\n    left: 0;\n    z-index: 5;\n    padding-bottom: 10%;\n    /* background: #131313 url(\"../assets/img/line_bg1@3x.png\") no-repeat 0% 100%;\n      background-size: 50% 60%; */\n    color: #fff;\n  }\n  .magic-section p {\n    font-size: 1em;\n    padding: 1.65em;\n  }\n  .flex-row .magic-section {\n    padding-top: 10em;\n  }\n  .carousel-container,\n  .contact-mobile {\n    padding-top: 3em;\n  }\n  .seperator {\n    display: none;\n  }\n  .carousel div {\n    width: 100%;\n    height: 12em;\n  }\n\n  .content p {\n    margin-bottom: 0;\n  }\n  .about-banner {\n    background-size: 450%;\n    background-position: bottom;\n  }\n  .top-pad-header-mobile {\n    padding-top: 70%;\n  }\n  .seperator-right {\n    padding-left: 0;\n  }\n  .left-of-seperator,\n  .right-of-seperator {\n    width: 100%;\n    font-size: 0.75em;\n    padding: 0;\n    text-align: left;\n  }\n  .left-of-seperator h4,\n  .right-of-seperator h4 {\n    font-weight: 600;\n    font-size: 1.4em;\n  }\n  .item-right p {\n    padding-right: 0em;\n  }\n\n  .right-of-seperator {\n    margin-top: 1.5em;\n    margin-left: 0;\n  }\n  .row-ul-mobile {\n    flex-direction: row;\n  }\n  .underlined-text {\n    padding-bottom: 2em;\n  }\n  .about-done-that .nav li,\n  .reasons {\n    display: none;\n  }\n  .about-done-that h3 {\n    font-size: 1.4em;\n  }\n\n  .reason-mobile {\n    background: linear-gradient(\n      163.54deg,\n      #676767 10.41%,\n      #0d0d0d 36.63%,\n      #131313 100%\n    );\n    margin-top: -5%;\n    color: #fff;\n  }\n  .reason-heading-mobile {\n    padding: 3em 0 13em;\n    font-size: 1em;\n    text-align: center;\n  }\n  .triangle-right {\n    width: 0;\n    height: 0;\n    border-top: 30vh solid transparent;\n    border-left: 100vw solid rgb(89, 89, 89);\n    border-bottom: 30vh solid transparent;\n    position: relative;\n    margin-top: -30vh;\n  }\n  .triangle-left {\n    width: 0;\n    height: 0;\n    border-top: 30vh solid transparent;\n    border-right: 100vw solid rgb(66, 66, 66);\n    border-bottom: 30vh solid transparent;\n    margin-top: -30vh;\n    position: relative;\n  }\n  .triangle-right h4 {\n    right: 38vw;\n    position: absolute;\n    top: -1.2em;\n    width: 55vw;\n    text-align: left;\n    text-transform: uppercase;\n    font-size: 1.4em;\n  }\n  .triangle-left h4 {\n    left: 35vw;\n    position: absolute;\n    top: -1em;\n    width: 55vw;\n    text-align: right;\n    text-transform: uppercase;\n    font-size: 1.4em;\n  }\n  .triangle-right p {\n    right: 42vw;\n    position: absolute;\n    top: 0.5em;\n    width: 51vw;\n    text-align: left;\n    font-size: 5.5vw;\n  }\n  .triangle-left p {\n    left: 40vw;\n    position: absolute;\n    top: 0.7em;\n    width: 50vw;\n    text-align: right;\n    font-size: 5.5vw;\n  }\n  .solve,\n  .bvb,\n  .reality {\n    background-size: 15%;\n  }\n  /* h3{\n  font-size: 1.4em;\n} */\n  .mobile-top-spacing {\n    padding-top: 1em;\n  }\n  h4 {\n    font-size: 1.2em;\n  }\n  .mailbox {\n    padding: 2.5em 2% 2.5em 7% !important;\n  }\n  .footer-contact {\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    font-size: 0.6em;\n  }\n  .footer-contact div:nth-child(1) {\n    padding: 0;\n    padding-top: 2em;\n  }\n  .footer-contact div:nth-child(2) {\n    padding: 0;\n    padding-bottom: 2em;\n  }\n  .seperator-friendly {\n    padding: 2em 0 0;\n    text-align: left;\n  }\n  .seperator-friendly h3 {\n    font-weight: bold;\n  }\n  svg {\n    height: 80vh;\n  }\n  .work-banner h2,\n  .about-banner h2,\n  .contact-banner h2 {\n    font-size: 9vw;\n    width: 90%;\n    align-self: center;\n  }\n  .work-banner div,\n  .about-banner div {\n    gap: 2.5em;\n  }\n  .third-left-child {\n    margin-top: 1.5em;\n  }\n  .custom-questionnaire {\n    margin: 0.5em 1.5em 0.5em 0.5em;\n    min-height: 50vh;\n    height: auto;\n    max-height: 500vh;\n    z-index: 0;\n  }\n  .MuiStepLabel-root .MuiStepLabel-labelContainer .Mui-active {\n    font-size: 1em;\n  }\n  .user-box,\n  .email-box {\n    padding-left: 3em;\n  }\n  .email-submit {\n    background: #eee url(../assets/img/Union.png) no-repeat 34% 52%;\n    background-size: auto 50%;\n  }\n\n  .form-function-text {\n    font-size: 1.8em;\n    line-height: 1.1em;\n  }\n  .solution-img {\n    width: 100%;\n    opacity: 1;\n    transform: translate(0%, 0%);\n  }\n  .solution-img-opposite {\n    width: 100%;\n    opacity: 1;\n    transform: translate(0%, 0%);\n  }\n  .emr,\n  .itlfm {\n    margin: 0;\n    background-position: 0 0;\n  }\n  .work-details li {\n    height: 60vh;\n  }\n  .products-home {\n    width: 100%;\n    margin-top: 4vh;\n  }\n  .products-home > div {\n    margin-bottom: 5vh;\n    position: relative;\n  }\n  .products-home > div > img {\n    width: 100%;\n    cursor: pointer;\n  }\n  .fleetimg {\n    margin-left: -20%;\n    /* width: 120vh; */\n  }\n  .fleet .picarroimg {\n    margin-left: -15%;\n  }\n  .products-home p {\n    position: absolute;\n    bottom: 0em;\n    width: 100%;\n    text-align: center;\n  }\n  .products-home p:nth-child(2) {\n    display: none;\n  }\n  .carousel-bg {\n    height: 25vh;\n  }\n  .MuiBox-root {\n    width: 100%;\n  }\n  .contactus-form {\n    width: 95%;\n  }\n  .email-submit {\n    right: -2%;\n  }\n  .thankyou-font {\n    font-size: 2em;\n    left: 0;\n  }\n  .thanksyou-wrapper {\n    left: 0;\n    top: 45vh;\n    width: 100%;\n  }\n  .thanksyou-wrapper > p {\n    padding: 0em 2.5em 0em 2.5em;\n    text-align: center;\n  }\n\n  .about-map-img {\n    width: 100%;\n    height: 40vh;\n  }\n  .services-content {\n    margin-top: 0;\n    line-height: 0;\n  }\n  .services-text {\n    padding-top: 0em;\n  }\n  .reasons-heading {\n    padding-bottom: 3em;\n    padding-top: 1em !important;\n  }\n  .modal-content-wrapper {\n    overflow-y: scroll;\n    height: 100vh;\n    padding-bottom: 1em;\n    background-color: #000;\n    overflow-y: scroll !important;\n    -webkit-overflow-scrolling: touch;\n  }\n  .modal-text-wrapper {\n    color: white;\n    background: black;\n    padding: 2em;\n    height: 95vh;\n  }\n  .modal-text-wrapper a {\n    color: #fff;\n    font-weight: 600;\n  }\n  .say-hi-class {\n    width: 90%;\n  }\n  .gta img {\n    height: 100vh !important;\n    width: auto !important;\n    margin-left: -12% !important;\n  }\n  .ehr,\n  .pandemic,\n  .gta,\n  .fleet,\n  .italos {\n    opacity: 1;\n    transform: translate(0%, 0%);\n  }\n  .work-details-child {\n    position: relative;\n  }\n  .work-details-child .mobile-only {\n    position: absolute;\n    top: 0;\n    height: 100%;\n    z-index: 1;\n    color: #fff;\n    width: 100%;\n    background: linear-gradient(\n      180deg,\n      rgba(4, 4, 4, 0) 47.92%,\n      rgba(4, 4, 4, 0.5) 100%\n    );\n    font-weight: bold;\n    font-size: 2em;\n  }\n  .work-details-child .mobile-only h3 {\n    bottom: 1em;\n    left: 5vw;\n    position: absolute;\n  }\n\n  .lazy-images-odd {\n    width: 100vh !important;\n    margin-left: -22%;\n  }\n\n  .lazy-load-image-background {\n    overflow: hidden;\n  }\n\n  .lazy-images-even {\n    /* width: 100vh !important; */\n    margin-left: -52%;\n  }\n  .italos img {\n    height: 100vh !important;\n    width: auto !important;\n    margin-left: -12%;\n  }\n}\n\n.appimg {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  align-items: center;\n  padding-bottom: 4vmin;\n  height: 40vh;\n  width: 40%;\n  background: #ede8e2;\n  color: #3a3535;\n  visibility: hidden;\n}\n.image {\n  grid-row: 1;\n  grid-column: 1;\n  margin-left: -2rem;\n  opacity: 0.7;\n  -webkit-animation: image-in 1s cubic-bezier(0.5, 0, 0.1, 1) 0s backwards;\n  animation: image-in 1s cubic-bezier(0.5, 0, 0.1, 1) 0s backwards;\n  visibility: visible;\n}\n.nextChoice-container {\n  padding: 0.75em;\n}\n.delay1 {\n  -webkit-animation: image-in 1s cubic-bezier(0.5, 0, 0.1, 1) 1s backwards;\n  animation: image-in 1s cubic-bezier(0.5, 0, 0.1, 1) 1s backwards;\n}\n.delay2 {\n  -webkit-animation: image-in 1s cubic-bezier(0.5, 0, 0.1, 1) 2s backwards;\n  animation: image-in 1s cubic-bezier(0.5, 0, 0.1, 1) 2s backwards;\n}\n\n@-webkit-keyframes image-in {\n  from {\n    -webkit-clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);\n    clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);\n  }\n  to {\n    -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);\n    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);\n  }\n}\n@keyframes image-in {\n  from {\n    -webkit-clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);\n    clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);\n  }\n  to {\n    -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);\n    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);\n  }\n}\n.image img {\n  display: block;\n  width: 100%;\n  height: auto;\n  filter: grayscale(30%);\n}\n.image img:hover {\n  filter: grayscale(0%);\n}\n\n.close-icon {\n  position: absolute;\n  right: 0.5em;\n  top: 0.5em;\n  width: 1.5em;\n  z-index: 100;\n  background-color: rgba(0, 0, 0, 0.5);\n  border-radius: 0.75em;\n}\n.close-icon img {\n  width: 1.5em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
